const i18nConfig = {
    locales: ['en', 'fr', 'it', 'es', 'ar', 'pt', 'uk'],
    defaultLocale: 'en'
}

export default i18nConfig
